import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const homeRedirectRoute: InvariantJiraRoute = {
	name: 'home-redirect',
	path: '/jira',
	exact: true,
};
